// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"ModalConfirm_backdrop__3PSgI","modal":"ModalConfirm_modal__3Ktct","slide-down":"ModalConfirm_slide-down__2COPZ"};